// USD tutar biçimi TEK kaynak (Finar UX P2 İ3) — 2 ondalık, tr-TR ayraçları ("$1.234,57").
// Ham `toFixed(4)` / nokta ayraçlı `toFixed(2)` maliyet kartlarında kullanılmaz.

const USD = new Intl.NumberFormat("tr-TR", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Sıfır değil ama 1 sentin altındaki tutar "$0,00" görünüp yanıltmasın. */
const BELOW_CENT = `< ${USD.format(0.01)}`;

export function formatUsd(value: number): string {
  if (!Number.isFinite(value)) return "—";
  if (value > 0 && value < 0.005) return BELOW_CENT;
  return USD.format(value);
}
